function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LazyLoader } from "../../components/layout/LazyLoader";
import { getLazyProps } from "./utils/getLazyProps";
import { getComponentProps } from "./utils/getComponentProps";
export var withLazyLoad = function withLazyLoad() {
  for (var _len = arguments.length, lazyPropsKeys = new Array(_len), _key = 0; _key < _len; _key++) {
    lazyPropsKeys[_key] = arguments[_key];
  }

  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
      _inherits(WrapperComponent, _Component);

      var _super = _createSuper(WrapperComponent);

      function WrapperComponent() {
        var _this;

        _classCallCheck(this, WrapperComponent);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this), "render", function () {
          var lazyProps = getLazyProps(_this.props, lazyPropsKeys);
          var componentProps = getComponentProps(_this.props, lazyPropsKeys);
          var isLazyLoaded = _this.props.isLazyLoaded;

          if (isLazyLoaded) {
            return React.createElement(LazyLoader, {
              componentProps: componentProps,
              lazyProps: lazyProps
            }, React.createElement(WrappedComponent, null));
          }

          return React.createElement(WrappedComponent, _this.props);
        });

        return _this;
      }

      return WrapperComponent;
    }(Component), _defineProperty(_class, "displayName", "withLazyLoad(".concat(WrappedComponent.displayName, ")")), _defineProperty(_class, "defaultProps", {
      isLazyLoaded: true
    }), _defineProperty(_class, "propTypes", {
      isLazyLoaded: PropTypes.bool
    }), _temp;
  };
};